import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import { authInfo } from '../../actions'
import { uploadImage } from '../../lib/upload';
import { browserHistory } from 'react-router';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import { cyan900, cyan500 } from 'material-ui/styles/colors';
import DialogModal from '../home/DialogModal';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import _ from 'lodash';

const propTypes = {
  product: PropTypes.object,
  categories: PropTypes.any,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  products: PropTypes.any,
};
const dropzoneStyles ={
  border: '10px',
  boxSizing: 'border-box',
  display: 'inline-block',
  cursor: 'pointer',
  outline: 'none',
  position: 'relative',
  height: '36px',
  lineHeight: '36px',
  borderRadius: '2px',
  transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  backgroundColor: 'rgb(0, 188, 212)',
  textAlign: 'center',
  fontSize: '14px',
  letterSpacing: '0px',
  fontWeight: '500',
  margin: '0px',
  userSelect: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  color: 'rgb(255, 255, 255)' }

  const clientOptions = {
    sessionCache: true
  }
  const client = window.filestack.init('AJPkbXMCpSHWIMU3KY6Ryz', clientOptions)

class EditProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogTitle: ' ',
      dialogMessage: ' ',
      dialogActionTitle: ' ',
      required: {
        name: null,
        description: null,
        parentCategory: null,
      },
      product: {
        id: 0,
        name: '',
        description: '',
        tagline: '',
        categories: '',
        category: '',
        disabled: false,
        newproduct: false,
        isTaxable: true,
        defaultItemId: 0,
        optionGroups: [],
        optionItems: [],
        img: '',
        yotpoId: '',
        allowsPersonalization: false,
        bleed: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
        altImages: [],
        parentCategory: 0,
        relatedCategory: null,
        preview: {
          portrait: [{
            img: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            angle: 0,
            index: 1,
            z: 0,
            zoomedOverlay: '',
            zoomedX: 0,
            zoomedY: 0,
            zoomedWidth: 0,
            zoomedHeight: 0,
          }],
          landscape: [{
            img: '',
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            angle: 0,
            index: 1,
            z: 0,
            zoomedOverlay: '',
            zoomedX: 0,
            zoomedY: 0,
            zoomedWidth: 0,
            zoomedHeight: 0,
          }],
          numPhotos: 1,
        },
        slug: '',
        attributes: [],
        overlayDisabled: false,
        productVideoUrl: '',
      },
      productCategories: [
        { name: 'acrylic'},
        { name: 'acrylic-block'},
        { name: 'metal'},
        { name: 'glass'},
        { name: 'wood'},
        { name: 'frames-canvas'},
        { name: 'ornaments'},
        { name: 'expressions'},
        { name: 'gift-guide'},
        { name: "table-top"},
        { name: "wall"},
        { name: "modern"},
        { name: "minis"},
        { name: "classic"},
        { name: "best-sellers"},
        { name: "collage"},
        { name: "magnets"},
        { name: "new"},
        { name: "office"},
      ],
      open: false,
      edited: false,
      viewRedirect: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.product) {
      const product = nextProps.product;
      product.defaultItemId = (product.defaultItemId === null) ? 0 : product.defaultItemId;
      product.attributes = (product.attributes === null) ? [] : product.attributes
      this.setState({ product });
    }
    this.setRequiredParams();
  }
  setRequiredParams() {
    const required = this.state.required;
    const product = this.state.product;
    Object.keys(this.state.required).forEach((paramName) => {
      const param = product[paramName];
      required[paramName] = (param == null || param.length === 0 || param === 0) ? 'This field is required' : null;
    });
    this.setState({ required });
  }
  handleCategoryChange(index, value, category) {
    const product = this.state.product;
    product[category] = value;
    this.setState({
      product,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleAttributeChange(event, index, value, t) {
    const product = this.state.product;
  if (Array.isArray(product[t])) {
    (product[t].includes(value)) ? _.pull(product[t], value) : product[t].push(value); // eslint-disable-line
  } else {
    _.set(product, product[t], value)
  }
  this.setState({
    product
  })
}
  handleChange(e) {
    const product = this.state.product;
    if (e.target.type === 'checkbox') {
      _.set(product, e.target.name, e.target.checked);
    } else {
      _.set(product, e.target.name, e.target.value);
    }
    this.setState({
      product,
      edited: true,
    });
    this.setRequiredParams();
  }
  handleDeleteOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Delete Product';
    nextState.dialogMessage = 'Do you really want to delete this product?';
    nextState.dialogActionTitle = 'Delete';
    nextState.open = true;
    nextState.delete = true;
    this.setState({ nextState });
  }
  navigateToView() {
    if (this.state.edited === true) {
      const nextState = this.state;
      nextState.viewRedirect = true;
      this.setState(nextState);
      this.handleOpen();
    } else {
      browserHistory.push(`/products/view/${this.state.product.id}`);
    }
  }
  handleCancel() {
    browserHistory.push('/products?page=1');
  }
  handleClose() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    if (this.state.viewRedirect) {
      browserHistory.push(`/products/view/${this.state.product.id}`);
    }
  }
  handleOpen() {
    const nextState = this.state;
    nextState.dialogTitle = 'Save Product Changes';
    nextState.dialogMessage = 'Do you really want to save the changes in this product?';
    nextState.dialogActionTitle = 'Save';
    nextState.open = true;
    this.setState({ nextState });
  }
  saveChanges() {
    this.setState({
      open: false,
      edited: false,
      viewRedirect: false,
    });
    const product = _.omit(this.state.product, ['parentCategoryName', 'parCatName', 'relCatName']);
    switch (true) {
      case (this.state.delete):
        this.props.onDelete(this.props.product.id);
        break;
      case (this.state.edited && this.state.viewRedirect):
        this.props.onView(product);
        break;
      default:
        this.props.onSave(product);
        break;
    }
  }
  handleUploadedImage(name, value) {
    const nextState = this.state.product;
    _.set(nextState, name, value)
    this.setState({
      product: nextState,
      edited: true,
    });
    this.setRequiredParams()
  }
  onDrop (file, bucket) {
    const { dispatch, product } = this.props
    const token = authInfo(dispatch)
    uploadImage(file, bucket, token, product.id)
      .then((response) => {
        this.handleChange({
          target: {
            name: 'img',
            value: response.fileName
          }
        })
      })
      .catch((err) => {
        console.log('# got back ERROR from uploadImage: ', err);
        this.handleChange({
          target: {
            name: 'img',
            value: file[0].name
          }
        })
        // alert(`Image upload failed: ${er}`);
        return '';
      });
  }

  render() {
    console.log('PRODUCT', this.props.product)
    const categorySelect = _.map(this.props.categories, (c, i) =><MenuItem value={c.id} key={(i + 1)} primaryText={c.name} />);
    const productCategorySelect = _.map(this.state.productCategories, (c, i) => {
    return <MenuItem value={c.name} key={(i + 1)} primaryText={c.name} />})
    const attributeNames = this.state.product.attributes
    const attributesSelect = _.map(this.state.productCategories, (c, i) => {
      return <MenuItem value={c.name} key={(i + 1)} primaryText={c.name} checked={attributeNames && attributeNames.includes(c.name)}/>})
    const styles = {
      floatingLabelStyle: {
        color: cyan900,
      },
      inputStyle: {
        marginRight: '2%',
        width: '250px',
      },
      wideStyle:{
        marginRight: '2%',
        width: '700px',
      },
      inputStyleURL: {
        marginRight: '1%',
        width: '100%'
      },
    };
    return (
      <div>
        <DialogModal
          dialogOpen={this.state.open}
          dialogHandleClose={this.handleClose}
          dialogHandleSubmit={() => this.saveChanges()}
          dialogTitle={this.state.dialogTitle}
          dialogMessage={this.state.dialogMessage}
          dialogActionTitle={this.state.dialogActionTitle}
        />
        <div className="float-right">
          <RaisedButton
            label="Cancel"
            style={{ marginRight: '10px' }}
            primary
            onClick={this.handleCancel}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="View"
            primary
            onClick={this.navigateToView}
          />
          <RaisedButton
            style={{ marginRight: '10px' }}
            label="Delete"
            primary
            onClick={this.handleDeleteOpen}
          />
          <RaisedButton
            label="Save"
            primary
            onClick={this.handleOpen}
          />
        </div>
        <br />
        <TextField
          floatingLabelText="ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          inputStyle={styles.inputStyle}
          value={this.state.product.id}
          disabled
        />
        <br />
        <TextField
          floatingLabelText="Name"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.name}
          name="name"
          onChange={this.handleChange}
          style={styles.inputStyle}
          errorText={this.state.required.name}
          errorStyle={{ color: cyan500 }}
        />
        <TextField
          floatingLabelText="Tagline"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.tagline}
          name="tagline"
          onChange={this.handleChange}
          style={styles.inputStyle}
          multiLine={true}
        />
        <SelectField
          floatingLabelText="Parent Category"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed
          name="parentCategory"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          value={this.state.product.parentCategory}
          errorText={this.state.required.parentCategory}
          errorStyle={{ color: cyan500 }}
          onChange={(event, index, value) => this.handleCategoryChange(index, value, 'parentCategory')}
        >
          <MenuItem value={0} key={0} primaryText="None" />
          {categorySelect}
        </SelectField>
        <SelectField
          floatingLabelText="Related Category"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed
          name="relatedCategory"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          value={this.state.product.relatedCategory}
          onChange={(event, index, value) => this.handleCategoryChange(index, value, 'relatedCategory')}
        >
          <MenuItem value={null} key={0} primaryText="None" />
          {categorySelect}
        </SelectField>
        <SelectField
          floatingLabelText="Product Category"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed
          name="category"
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          value={this.state.product.category}
          onChange={(event, index, value) => this.handleCategoryChange(index, value, 'category')}
        >
          <MenuItem value={null} key={0} primaryText="None" />
          {productCategorySelect}
        </SelectField>
        <SelectField
          floatingLabelText="Attributes"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed
          name="attributes"
          multiple={true}
          style={{ verticalAlign: 'bottom', marginRight: '2%', width: '250px' }}
          value={this.state.product.attributes || []}
          onChange={(event, index, value) => this.handleAttributeChange(event, index, value, 'attributes')}
        >
          <MenuItem value={null} key={0} primaryText="None" />
          {attributesSelect}
        </SelectField>
        <TextField
          floatingLabelText="Slug"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.slug}
          name="slug"
          onChange={this.handleChange}
          style={styles.inputStyle}
          multiLine={true}
        />
        <br/>
        <TextField
          floatingLabelText="Yotpo ID"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.yotpoId}
          name="yotpoId"
          onChange={this.handleChange}
          style={styles.inputStyle}
        />
        <TextField
          floatingLabelText="Image"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.img}
          name="img"
          onChange={this.handleChange}
          style={styles.inputStyleURL}
        />
        <button
          className="filestack-button"
          onClick={(e) => {
            e.preventDefault;
            return client.picker({
              uploadInBackground: false,
              onUploadDone: ((res) => {
                console.log('RES FROM FILESTACK', res);
                const targetName = 'img'
                const targetValue = res.filesUploaded[0].url
                this.handleUploadedImage(targetName, targetValue)
              })
            }).open()
          }}
          style={dropzoneStyles}>
          <p className="filestack-uplaod">UPLOAD PHOTO</p>
        </button>
        <br />
        <br />
        <TextField
          floatingLabelText="Product Video Url"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.productVideoUrl}
          name="productVideoUrl"
          onChange={this.handleChange}
          style={styles.inputStyle}
        />
        <br/>
        <br/>
        <TextField
          floatingLabelText="Description"
          floatingLabelStyle={styles.floatingLabelStyle}
          floatingLabelFixed={true}
          value={this.state.product.description}
          name="description"
          onChange={this.handleChange}
          style={styles.wideStyle}
          errorText={this.state.required.description}
          errorStyle={{ color: cyan500 }}
          multiLine={true}
        />
        <br/>
        <br/>
        <ul>
        <li>
            <Checkbox
              label="New Product"
              defaultChecked={this.state.product.newproduct}
              name="newproduct"
              onCheck={this.handleChange}
            />
          </li>
          <li>
            <Checkbox
              label="Disabled"
              defaultChecked={this.state.product.disabled}
              name="disabled"
              onCheck={this.handleChange}
            />
          </li>
          <li>
            <Checkbox
              label="Product is Taxable"
              defaultChecked={this.state.product.isTaxable}
              name="isTaxable"
              onCheck={this.handleChange}
            />
          </li>
          <li>
            <Checkbox
              label="Allows Personalization"
              defaultChecked={this.state.product.allowsPersonalization}
              name="allowsPersonalization"
              onCheck={this.handleChange}
            />
          </li>
          <li>
          <Checkbox
            label="Bleed"
            checked={this.state.product.bleed}
            name="bleed"
            onCheck={this.handleChange}
          />
          </li>
          <li>
          <Checkbox
            label="Overlays Disabled"
            checked={this.state.product.overlayDisabled}
            name="overlayDisabled"
            onCheck={this.handleChange}
          />
          </li>
        </ul>
      </div>
    );
  }
}

EditProduct.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

EditProduct.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    product: state.products.product,
    categories: state.categories.results,
    products: state.products.results,
  };
}

export default connect(mapStateToProps)(EditProduct);



// WEBPACK FOOTER //
// ./src/components/products/EditProduct.js